// extracted by mini-css-extract-plugin
module.exports = {"molecule__tab-car-carousel-container":"styles_molecule__tab-car-carousel-container__4LQSD","slide-container":"styles_slide-container__h90YN","back-line":"styles_back-line__m8AEr"};